<footer class="fixed-bottom">
  <div class="footer-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 copyright">
          <span class="customFont">{{ footerConstant?.poweredBy}}</span>
          <img src="assets/images/footer-logo.png" alt="Footer Logo">
          <span class="customfooterFont">{{ footerConstant?.neoTxt }}<sup>&reg;</sup>&nbsp;&nbsp;{{ footerConstant?.platformTxt }}</span>
        </div>
      </div>
    </div>
  </div>
</footer>